import {useContext} from 'react'
import RouteInfoContext from './context'

const useCurrentRegion = (): string | undefined => {
  const {currentRegion} = useContext(RouteInfoContext)

  return currentRegion
}

export default useCurrentRegion
